import { z } from "zod";
import { Instant, LocalDate } from "./time.js";
/**
 * Call outcomes that flow back to the brain (§2 "results flow back"). Mirrors
 * the cloud `call_attempts` table. The brain is the source of truth; the cloud
 * holds these ≤7 days.
 */
/**
 * Twilio AnsweredBy classification. `machine_*` and `fax`/`unknown` NEVER count
 * as a dismissal — voicemail answering is not awakeness (§4 invariant).
 */
export const AnsweredBy = z.enum([
    "human",
    "machine_start",
    "machine_end_beep",
    "machine_end_silence",
    "machine_end_other",
    "fax",
    "unknown",
]);
/** How a dismissal was achieved. `none` = not dismissed. Hangup is never here. */
export const DismissalKind = z.enum(["none", "task_echo", "physical"]);
export const CallAttempt = z.object({
    id: z.string(),
    date: LocalDate,
    /** 1-based rung index within the morning. */
    attemptN: z.number().int().min(1),
    placedAt: Instant,
    answeredBy: AnsweredBy,
    dismissal: DismissalKind,
    /** Whether this attempt was past Hard Wake. */
    hardWake: z.boolean().default(false),
    /** Null until the re-verify callback resolves; true=still vertical. */
    reverifyOk: z.boolean().nullable().default(null),
});
//# sourceMappingURL=outcomes.js.map